import { keepPreviousData, useQuery } from '@tanstack/react-query'
import { QueryKey } from 'src/reactQuery/enums/queryKey.enum'
import { ReviewAnalysisApiService } from 'src/services/reviewAnalysisApi'
import { ReviewAnalysisDateRange } from 'src/services/reviewAnalysisApi/interfaces/reviewAnalysis.interface'

export const useGetReviewAnalysisGuestReviewsQuery = (
  campaignId: string,
  platform?: string,
  facilityIds: string[] = [],
  range?: ReviewAnalysisDateRange
) =>
  useQuery({
    enabled: !!campaignId,
    placeholderData: keepPreviousData,
    queryFn: () =>
      ReviewAnalysisApiService.getGuestReviews(campaignId, {
        facilityIds,
        platform,
        range,
      }),
    queryKey: [
      QueryKey.GET_REVIEW_ANALYSIS_GUEST_REVIEWS,
      campaignId,
      platform ?? '',
      facilityIds.join(','),
      range?.from ?? '',
      range?.to ?? '',
    ],
  })
